import { BasePageProps, BasePageState, basePageInitialState } from '../BasePage'

import { store } from '../../redux/store'

import { createReducer, createAction } from '@reduxjs/toolkit'

export interface CommercialPageProps extends BasePageProps {}

type CommercialState = {
    tipoVeicolo: string | undefined
    targa: string | undefined
    note: string | undefined

    tipoVeicoloError: string | undefined
    targaError: string | undefined
    noteError: string | undefined

    tipi_veicolo: any
}

export type CommercialPageState = CommercialState & BasePageState

export const commercialPageInitialState : CommercialPageState = {
    ...basePageInitialState,
    ...{
        tipoVeicolo: undefined,
        targa: undefined,
        note: undefined,

        tipoVeicoloError: undefined,
        targaError: undefined,
        noteError: undefined,

        tipi_veicolo: undefined,
    }
}

export const commercialhUpdate = createAction<CommercialPageState>('commercial/update')

export const commercialhReducer = createReducer ( 
    commercialPageInitialState,
    (builder) => {
        builder.addCase(commercialhUpdate, (state, action) => {
            return action.payload as CommercialPageState
        })
    }
)

export type CommercialRootState = ReturnType<typeof store.getState>
export type CommercialDispatch = typeof store.dispatch